var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-fields-wrapper" },
    [
      _c(
        "LfHeaderTitleComponent",
        {
          staticClass: "header-title",
          attrs: {
            title: "Campos personalizados",
            buttons: _vm.buttons,
            executeAction: _vm.executeAction,
          },
        },
        [
          _c("ShowOrHideButtonComponent", {
            staticClass: "preview-button",
            attrs: { show: _vm.showFormPreview, texts: _vm.formPreviewTexts },
            on: { toggle: _vm.toggleShowOrHide },
          }),
        ],
        1
      ),
      !_vm.showSpinnerLayer
        ? _c(
            "section",
            { class: ["custom-fields-container", _vm.breakpointClass] },
            [
              _vm.loadingData
                ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
                : [
                    _c("CustomFieldsInfoTextComponent", {
                      attrs: { showInfoText: _vm.showInfoText },
                      on: { "hide-info": _vm.hideInfo },
                    }),
                    _vm.showFormPreview
                      ? [
                          _c(
                            "div",
                            { staticClass: "custom-fields-preview" },
                            [
                              _c("CustomFieldsPreviewComponent", {
                                attrs: {
                                  schema: _vm.config.customFields,
                                  context: _vm.context,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _c(
                          "section",
                          { staticClass: "custom-fields-section" },
                          [
                            _c("CustomFieldTypeSelectorComponent", {
                              staticClass: "custom-fields-selector",
                              attrs: { items: _vm.getCustomFieldsTypes },
                              on: { "emit-clicked-item": _vm.openFormDialog },
                            }),
                            _c("CustomFieldsPlaygroundComponent", {
                              staticClass: "custom-fields-playground",
                            }),
                            _vm.formSchema
                              ? _c("CustomFieldsFormDialogComponent", {
                                  attrs: {
                                    showFormDialog: _vm.showFormDialog,
                                    typeOfFieldToRenderInForm:
                                      _vm.typeOfFieldToRenderInForm,
                                    schema: _vm.formSchema,
                                    formData: _vm.customFieldFormData,
                                  },
                                  on: { "dialog-event": _vm.dialogEvents },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }